import commonService from "../../common";
import myTicketsCommonService from "../../common/myTickets";

// 最も有効期間が後のframeの有効期限を取得する
export const getLatestCountDownLimit = (book) => {
  // Sheetを持たない場合は終了
  if (book.sheets.length === 0) {
    return "NoSheetsInUse";
  }

  // 使用済みのsheet(is_expired:true)を抽出
  const expiredSheetList = book.sheets.filter((sheet) => sheet.is_expired);

  // 使用済みsheetがなければ終了
  if (expiredSheetList.length === 0) {
    return "NoSheetsInUse";
  }

  // 使用済みsheetから、それぞれ最新の有効化済みframe情報を抽出
  // この後countDownの期限を計算するので、frameのstamped_at と sheetのFaceCountDown を抽出
  const latestFrameInfoPerSheetList = [];
  expiredSheetList.forEach((expiredSheet) => {
    commonService
      .sortByDateTimeLaterFirst(expiredSheet.frames)
      .forEach((frame) => {
        if (frame.stamped_at) {
          latestFrameInfoPerSheetList.push({
            stamped_at: frame.stamped_at,
            FaceCountDown:
              expiredSheet._master_sheet.content.description_json.FaceCountDown,
          });
          // sheetごとに1つでいいのでreturn
          return;
        }
      });
  });

  // 上記で抽出した情報から、各sheetのカウントダウン期限を算出
  const countDownLimitPerSheetList = latestFrameInfoPerSheetList.map(
    (frameInfo) =>
      myTicketsCommonService.getCountDownLimit(
        frameInfo.stamped_at,
        frameInfo.FaceCountDown
      )
  );

  // sheetのis_expired=trueだが全frameのstamped_at=nullの場合、使用中のsheetはないので終了
  if (countDownLimitPerSheetList.length == 0) {
    return "NoSheetsInUse";
  }

  // 各sheetのカウントダウン期限の中で、最も後のものを返す
  const latestCountDownLimit = commonService.sortByDateTimeLaterFirst(
    countDownLimitPerSheetList
  )[0];
  console.log(book.id, book.name, " >> ", latestCountDownLimit);
  return latestCountDownLimit;
};
